export const authLoginFormControlLocaleTexts = {
  submit: {
    text: 'ログイン',
  },
}
